export default "__VITE_ASSET__DgnwxgNH__"